/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDeviceServicesRestartMutationResponse, StreamerBoxStreamerBoxDeviceServicesRestartPathParams } from "../models/StreamerBoxStreamerBoxDeviceServicesRestart";

export function getStreamerBoxStreamerBoxDeviceServicesRestartUrl(uuidOrId: StreamerBoxStreamerBoxDeviceServicesRestartPathParams["uuidOrId"], imageId: StreamerBoxStreamerBoxDeviceServicesRestartPathParams["imageId"]) {
  const res = { method: 'POST', url: `/streamer-box/devices/${uuidOrId}/services/${imageId}/restart` as const }
  return res
}

/**
 * @description Restarts a service on the device for the given image id.
 * @summary Restart service
 * {@link /streamer-box/devices/:uuidOrId/services/:imageId/restart}
 */
export async function streamerBoxStreamerBoxDeviceServicesRestart(uuidOrId: StreamerBoxStreamerBoxDeviceServicesRestartPathParams["uuidOrId"], imageId: StreamerBoxStreamerBoxDeviceServicesRestartPathParams["imageId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StreamerBoxStreamerBoxDeviceServicesRestartMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getStreamerBoxStreamerBoxDeviceServicesRestartUrl(uuidOrId, imageId).url.toString(), ... requestConfig })
  return res.data
}